"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTerms = exports.StyledSubheading = exports.StyledRepresentative = exports.StyledPicture = exports.StyledImageWrapper = exports.StyledImageHeroContainer = exports.StyledImageHero = exports.StyledImageHeading = exports.StyledHeading = exports.StyledDescription = exports.StyledCopyWrapper = exports.StyledContentWrapper = exports.StyledButtons = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _picture = require("../../fuse-picture/src/picture");
var _grid = require("../../fuse-responsive-grid/src/grid");
var _typography = require("../../fuse-typography-element/src/typography");
var _imageHero2Config = require("./image-hero-2-config");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var contentWrapper = _imageHero2Config.styledComponentConfig.contentWrapper,
  imageHero = _imageHero2Config.styledComponentConfig.imageHero,
  imageWrapper = _imageHero2Config.styledComponentConfig.imageWrapper;
var spanButtonHoverCss = (0, _styledComponents.css)(["box-shadow:var(--elevation-shadow-xxs);background-color:var(--color-brand-mid);@media screen and (min-width:", "){box-shadow:var(--elevation-shadow-xs);}@media screen and (min-width:", "){box-shadow:var(--elevation-shadow-s);}"], _grid.gridConfig.m.minWidth, _grid.gridConfig.l.minWidth);
var StyledImageHero = exports.StyledImageHero = _styledComponents["default"].div.attrs({
  className: 'fuse-image-hero-2'
}).withConfig({
  displayName: "styled-image-hero-2__StyledImageHero",
  componentId: "sc-1v2m2sj-0"
})(["", ""], function (_ref) {
  var background = _ref.background;
  return "\n\t\tbackground-color: ".concat(imageHero.backgroundColor[background], ";\n\t\tborder: ").concat(imageHero.border[background], ";\n\t\tposition: relative;\n\t\ttext-decoration: none;\n\n\t\t&:hover .fuse-image-hero-2__span-button {\n\t\t\t").concat(spanButtonHoverCss, "\n\t\t}\n\n\t\t&:focus-visible .fuse-image-hero-2__span-button {\n\t\t\t").concat(spanButtonHoverCss, "\n\t\t}\n\n\t\t&:focus-visible {\n\t\t\toutline: var(--border-radius-s) solid var(--color-functional-focus);\n\t\t}\n\n\t\t&:active .fuse-image-hero-2__span-button {\n\t\t\tbox-shadow: inset 0 0 0 2px var(--color-global-white);\n\t\t\tcolor: var(--color-global-white);\n\t\t\tbackground-color: var(--color-brand-dark);\n\t\t}\n\t");
});
var StyledImageHeroContainer = exports.StyledImageHeroContainer = _styledComponents["default"].div.attrs({
  className: 'fuse-image-hero-2__container',
  'data-testid': 'fuse-image-hero-2-container-test-id'
}).withConfig({
  displayName: "styled-image-hero-2__StyledImageHeroContainer",
  componentId: "sc-1v2m2sj-1"
})(["display:flex;flex-direction:column;@media screen and (min-width:", "){flex-direction:", ";}"], _grid.gridConfig.m.minWidth, function (_ref2) {
  var imagePosition = _ref2.imagePosition;
  return imagePosition === 'right' ? "row-reverse" : "row";
});
var StyledImageWrapper = exports.StyledImageWrapper = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'imageRatio';
  }
}).attrs({
  className: 'fuse-image-hero-2__image-wrapper',
  'data-testid': 'fuse-image-hero-2__image-wrapper'
}).withConfig({
  displayName: "styled-image-hero-2__StyledImageWrapper",
  componentId: "sc-1v2m2sj-2"
})(["", ""], function (_ref3) {
  var variant = _ref3.variant,
    imageRatio = _ref3.imageRatio;
  return "\n\t\taspect-ratio: ".concat(variant === 'v2' ? '4/3' : 'auto', ";\n\t\talign-items: ").concat(imageWrapper.alignItems[variant], ";\n\t\tjustify-content: flex-end;\n\t\tdisplay: ").concat(imageWrapper.displayMobile[variant], ";\n\t\twidth: ").concat(imageWrapper.width.xxs[variant], ";\n\n\t\t@media screen and (min-width: ").concat(_grid.gridConfig.m.minWidth, ") {\n\t\t\taspect-ratio: ").concat(variant === 'v2' && imageRatio === '1:1' ? '1/1' : '4/3', ";\n\t\t\talign-items: center;\n\t\t\tdisplay: flex;\n\t\t\tflex: 0 0 ").concat(variant === 'v2' ? imageWrapper.width.m[variant][imageRatio] : imageWrapper.width.m[variant], ";\n\t\t}\n\n\t\t@media screen and (min-width: ").concat(_grid.gridConfig.l.minWidth, ") {\n\t\t\tflex: 0 0 ").concat(variant === 'v2' ? imageWrapper.width.l[variant][imageRatio] : imageWrapper.width.l[variant], ";\n\t\t\tmin-width: 334px;\n\t\t}\n\n\t");
});
var StyledPicture = exports.StyledPicture = (0, _styledComponents["default"])(_picture.Picture).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'imageRatio';
  }
}).attrs({
  className: 'fuse-image-hero-2__picture',
  'data-testid': 'fuse-image-hero-2-picture-test-id'
}).withConfig({
  displayName: "styled-image-hero-2__StyledPicture",
  componentId: "sc-1v2m2sj-3"
})([".fuse-picture__img{aspect-ratio:4/3;display:block;max-width:none;object-fit:cover;width:100%;}", ""], function (_ref4) {
  var variant = _ref4.variant,
    imageRatio = _ref4.imageRatio;
  return variant === _imageHero2Config.variants.v3 ? "\n\t\t\t\t@media screen and (max-width: ".concat(_grid.gridConfig.s.maxWidth, ") {\n\t\t\t\t\tflex: 0 0 50%;\n\t\t\t\t\tmax-width: 50%;\n\t\t\t\t}\n\n\t\t\t") : "\n\t\t\t\t@media screen and (min-width: ".concat(_grid.gridConfig.m.minWidth, ") {\n\t\t\t\t\t.fuse-picture__img {\n\t\t\t\t\t\taspect-ratio: ").concat(imageRatio === '1:1' ? '1/1' : '4/3', ";\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t");
});
var StyledImageHeading = exports.StyledImageHeading = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-image-hero-2__image-heading',
  'data-testid': 'fuse-image-hero-2-image-heading-test-id'
}).withConfig({
  displayName: "styled-image-hero-2__StyledImageHeading",
  componentId: "sc-1v2m2sj-4"
})(["flex:0 0 50%;padding:var(--spacing-global-space3);max-width:50%;width:fit-content;@media screen and (min-width:", "){display:none;}"], _grid.gridConfig.m.minWidth);
var StyledContentWrapper = exports.StyledContentWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-image-hero-2__content-wrapper',
  'data-testid': 'fuse-image-hero-2__content-wrapper'
}).withConfig({
  displayName: "styled-image-hero-2__StyledContentWrapper",
  componentId: "sc-1v2m2sj-5"
})(["", ";"], function (_ref5) {
  var imagePosition = _ref5.imagePosition,
    noMobileContentPadding = _ref5.noMobileContentPadding,
    variant = _ref5.variant;
  return "\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tflex-grow: 1;\n\t\tjustify-content: center;\n\t\tgap: ".concat(contentWrapper.gap.xxs[variant], ";\n\t\tpadding: ").concat(noMobileContentPadding ? '0' : contentWrapper.padding.xxs[variant], "; /* No padding when all text and buttons are absent apart from headline for mobile */\n\t\tz-index: 1;\n\n\t\t@media screen and (min-width: ").concat(_grid.gridConfig.m.minWidth, ") {\n\t\t\tgap: ").concat(contentWrapper.gap.m[variant], ";\n\t\t\tpadding: ").concat(contentWrapper.padding.m[variant][imagePosition], ";\n\t\t}\n\t\t@media screen and (min-width: ").concat(_grid.gridConfig.l.minWidth, ") {\n\t\t\tgap: ").concat(contentWrapper.gap.l[variant], ";\n\t\t\tpadding: ").concat(contentWrapper.padding.l[variant], ";\n\t\t}\n\t");
});
var StyledCopyWrapper = exports.StyledCopyWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-image-hero-2__text-content',
  'data-testid': 'fuse-image-hero-2__text-content'
}).withConfig({
  displayName: "styled-image-hero-2__StyledCopyWrapper",
  componentId: "sc-1v2m2sj-6"
})(["box-sizing:border-box;display:flex;flex-direction:column;gap:var(--spacing-global-space3);justify-content:center;"]);
var StyledHeading = exports.StyledHeading = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-image-hero-2__heading',
  'data-testid': 'fuse-image-hero-2__heading'
}).withConfig({
  displayName: "styled-image-hero-2__StyledHeading",
  componentId: "sc-1v2m2sj-7"
})(["width:fit-content;@media screen and (min-width:", "){gap:var(--spacing-global-space6);}@media screen and (max-width:", "){display:", ";}"], _grid.gridConfig.m.minWidth, _grid.gridConfig.s.maxWidth, function (_ref6) {
  var variant = _ref6.variant;
  return variant === _imageHero2Config.variants.v3 ? 'none' : 'block';
});
var StyledSubheading = exports.StyledSubheading = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-image-hero-2__subheadline',
  'data-testid': 'fuse-image-hero-2__subheadline'
}).withConfig({
  displayName: "styled-image-hero-2__StyledSubheading",
  componentId: "sc-1v2m2sj-8"
})([""]);
var StyledDescription = exports.StyledDescription = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-image-hero-2__description',
  'data-testid': 'fuse-image-hero-2__description'
}).withConfig({
  displayName: "styled-image-hero-2__StyledDescription",
  componentId: "sc-1v2m2sj-9"
})(["margin-bottom:0;strong{font-weight:var(--font-weight-heading);}@media screen and (min-width:", "){padding-right:var(--spacing-global-space4);}"], _grid.gridConfig.m.minWidth);
var backgroundLightRep = function backgroundLightRep(prop) {
  return prop.background === 'brandLight' ? 'var(--color-brand-dark)' : 'var(--color-brand-mid)';
};
var StyledRepresentative = exports.StyledRepresentative = (0, _styledComponents["default"])(_typography.TypographyComponent).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'representativeColour';
  }
}).attrs({
  className: 'fuse-image-hero-2__representative',
  'data-testid': 'fuse-image-hero-2__representative'
}).withConfig({
  displayName: "styled-image-hero-2__StyledRepresentative",
  componentId: "sc-1v2m2sj-10"
})(["color:", ";span.fuse-image-hero-2__wrap-apr{display:inline-flex;}"], function (_ref7) {
  var representativeColour = _ref7.representativeColour;
  return representativeColour === 'grey' ? 'var(--color-global-grey900)' : backgroundLightRep;
});
var StyledTerms = exports.StyledTerms = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-image-hero-2__terms',
  'data-testid': 'fuse-image-hero-2__terms'
}).withConfig({
  displayName: "styled-image-hero-2__StyledTerms",
  componentId: "sc-1v2m2sj-11"
})(["margin-bottom:0;strong{font-weight:var(--font-weight-heading);}"]);
var StyledButtons = exports.StyledButtons = _styledComponents["default"].div.attrs({
  className: 'fuse-image-hero-2__buttons',
  'data-testid': 'fuse-image-hero-2-buttons-test-id'
}).withConfig({
  displayName: "styled-image-hero-2__StyledButtons",
  componentId: "sc-1v2m2sj-12"
})(["display:flex;flex-wrap:wrap;gap:var(--spacing-global-space5);@media screen and (min-width:", "){gap:var(--spacing-global-space6);}&.fuse-image-hero-2__buttons--stacked{flex-direction:column;gap:var(--spacing-global-space4);width:fit-content;}.fuse-image-hero-2__primary-button--stacked,.fuse-image-hero-2__secondary-button--stacked{width:100%;}"], _grid.gridConfig.l.minWidth);